import React, { useState } from "react";
import { Star, Quote } from "lucide-react";
import { imgFallback } from "@/lib/compare";

export const Gallery = ({ product }) => {
  const imgs = [...new Set([product.image_url, ...(product.images || [])].filter(Boolean))];
  const [active, setActive] = useState(0);
  return (
    <div className="space-y-3">
      <div className="aspect-square rounded-[2rem] bg-white border-2 border-primary-100 overflow-hidden" data-testid="product-main-image">
        <img src={imgs[active]} alt={product.title} className="w-full h-full object-contain" onError={imgFallback} />
      </div>
      {imgs.length > 1 && (
        <div className="flex gap-2 overflow-x-auto no-scrollbar" data-testid="product-thumbs">
          {imgs.map((src, i) => (
            <button key={src} type="button" onClick={() => setActive(i)} className={`shrink-0 w-16 h-16 rounded-2xl overflow-hidden border-2 bg-white ${i === active ? "border-primary-600" : "border-primary-100"}`} data-testid={`product-thumb-${i}`}>
              <img src={src} alt="" className="w-full h-full object-contain" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export const Stars = ({ value, size = "w-4 h-4" }) => (
  <span className="inline-flex">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className={`${size} ${i <= Math.round(value) ? "fill-secondary-500 text-secondary-500" : "text-primary-200"}`} />
    ))}
  </span>
);

export const Reviews = ({ product }) => {
  if (!product.rating && !(product.reviews || []).length) return null;
  return (
    <section className="rounded-[2rem] bg-white border-2 border-primary-100 p-5 sm:p-8" data-testid="product-reviews">
      <div className="flex flex-wrap items-center gap-4 mb-5">
        <h2 className="font-heading text-2xl font-extrabold text-primary-900">Ratings & reviews</h2>
        {product.rating ? (
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5" data-testid="product-rating-summary">
            <span className="font-extrabold text-primary-900">{product.rating}</span>
            <Stars value={product.rating} />
            {product.review_count ? <span className="text-sm text-primary-600">{product.review_count.toLocaleString("en-IN")} ratings</span> : null}
          </span>
        ) : null}
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {(product.reviews || []).map((r, i) => (
          <article key={i} className="rounded-2xl bg-primary-50 p-4" data-testid={`product-review-${i}`}>
            <Quote className="w-5 h-5 text-primary-300 mb-2" />
            <p className="text-sm text-primary-800 leading-relaxed">{r.text}</p>
            <div className="mt-3 flex items-center justify-between text-xs text-primary-500">
              <span className="font-bold">{r.author || "Customer"}</span>
              {r.rating ? <Stars value={r.rating} size="w-3 h-3" /> : null}
            </div>
          </article>
        ))}
      </div>
      {product.source_site && <p className="text-xs text-primary-400 mt-4">Ratings and reviews sourced from {product.source_site}.</p>}
    </section>
  );
};
